import React, {useEffect, useState} from 'react'
import './projects.less'
import {Project} from '../../entities/project'
import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import * as Icons from '@fortawesome/free-solid-svg-icons'
import {Link, useLoaderData, useNavigation} from 'react-router-dom'
import {useIntl} from 'react-intl'
import {Card} from 'antd'
const {Meta} = Card
import urlProjectPhoto0 from 'url:../../../public/assets/images/image1.jpg'

export function Projects({isSnapshot = false}: {isSnapshot?: boolean}) {
  const projects = useLoaderData() as Project[]
  const navigation = useNavigation()
  const intl = useIntl()

  return (
    <div className="projects">
      <h2 className="projects">
        {isSnapshot
          ? intl.formatMessage({id: 'mySnapshots'})
          : intl.formatMessage({id: 'myProjects'})}
      </h2>

      <div className="projects__list">
        {projects.map((project) => (
          <Link
            to={(isSnapshot ? 'snapshots/' : '') + project.id}
            key={project.id}
            className="projects__link"
            style={{
              paddingBottom: '20px',
            }}
          >
            <Card
              className="projects__card"
              hoverable
              style={{
                width: 400,
                minHeight: 300,
                margin: 10,
                height: '100%',
              }}
              cover={
                <img
                  className="projects__cover"
                  style={{width: 400, height: 200}}
                  alt="image"
                  src={
                    project.photo
                      ? `http://${window.location.host}${project.photo}`
                      : urlProjectPhoto0
                  }
                />
              }
            >
              <Meta title={project.name} description={project.description} />
            </Card>
          </Link>
        ))}

        {!isSnapshot && (
          <Link to={'/projects/new'} className="projects__link">
            <Card
              className="projects__card"
              hoverable
              style={{width: 400, minHeight: 300, margin: 10, height: '100%'}}
              cover={
                <Icon
                  className="projects__cover"
                  style={{width: 400, height: 200, color: '#ffd591'}}
                  icon={Icons.faPlus}
                />
              }
            >
              <Meta title={intl.formatMessage({id: 'createNewProject'})} />
            </Card>
          </Link>
        )}
      </div>
    </div>
  )
}
